import React from 'react';

export const SuggestionFieldChatbot = ({ props }) => {
  const { filteredBusinesses, handleSuggestionClick } = props;

  return (
    <div
      style={{
        position: 'absolute',
        top: '100%',
        left: 0,
        right: 0,
        border: '1px solid rgba(255,255,255,0.15)',
        borderRadius: 10,
        marginTop: 4,
        maxHeight: 350,
        overflowY: 'auto',
        backdropFilter: 'blur(12px)',
      }}
    >
      {filteredBusinesses.slice(0, 10).map((business) => (
        <div
          key={business.business_id}
          onClick={() => handleSuggestionClick(business)}
          style={{
            padding: '10px 12px',
            cursor: 'pointer',
            borderBottom: '1px solid rgba(255,255,255,0.08)',
            color: '#fff',
            fontSize: '14px',
          }}
          onMouseEnter={(e) => {
            e.target.style.background = 'rgba(74,211,255,0.1)';
          }}
          onMouseLeave={(e) => {
            e.target.style.background = 'transparent';
          }}
        >
          <div style={{ fontWeight: 600 }}>{business.business_id}</div>
          {business.name && (
            <div
              style={{
                fontSize: '12px',
                color: 'rgba(255,255,255,0.7)',
                marginTop: 2,
              }}
            >
              {business.name}
            </div>
          )}
        </div>
      ))}
    </div>
  );
};
